import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Suspense, useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { LANGUAGES, ROUTES, productPath } from '@/lib/constants'

// Layout
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import ScrollToTop from '@/components/shared/ScrollToTop'

// Pages
import Home from '@/pages/Home'
import Products from '@/pages/Products'
import ProductPage from '@/pages/ProductPage'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import NotFound from '@/pages/NotFound'

function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  )
}

function App() {
  const { i18n } = useTranslation()

  useEffect(() => {
    const dir = LANGUAGES[i18n.language as keyof typeof LANGUAGES]?.dir || 'rtl'
    document.documentElement.dir = dir
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <div className="flex min-h-screen flex-col">
            <a
              href="#main"
              className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
            >
              Skip to content
            </a>
            <Header />
            <main id="main" className="flex-1">
              <Routes>
                <Route path={ROUTES.HOME} element={<Home />} />
                <Route path={ROUTES.PRODUCTS} element={<Products />} />
                <Route path="/products/:slug" element={<ProductPage />} />

                {/* Legacy URLs → their current home */}
                <Route path="/products/tdrem-bell" element={<Navigate to={productPath('school-bell')} replace />} />
                <Route path="/products/tdrem-connect" element={<Navigate to={productPath('mosque')} replace />} />
                {/* The outsourcing / services offering was retired. */}
                <Route path="/services" element={<Navigate to={ROUTES.PRODUCTS} replace />} />
                <Route path="/hardware" element={<Navigate to={ROUTES.HOME} replace />} />

                <Route path={ROUTES.ABOUT} element={<About />} />
                <Route path={ROUTES.CONTACT} element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App
